function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
  x: 24.02,
  y: 29.877,
  fill: "#333333",
  width: 9.666,
  height: 2.813
}), /*#__PURE__*/React.createElement("rect", {
  x: 24.02,
  y: 22.992,
  fill: "#333333",
  width: 19.969,
  height: 2.813
}), /*#__PURE__*/React.createElement("rect", {
  x: 24.02,
  y: 16.107,
  fill: "#333333",
  width: 19.969,
  height: 2.813
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#333333",
  points: "14.191,16.107 8.597,16.107 8.597,10.514 5.785,10.514 5.785,16.107 0.191,16.107 0.191,18.92  5.785,18.92 5.785,24.514 8.597,24.514 8.597,18.92 14.191,18.92  "
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333333",
  d: "M39.638,0H18.191v40h31.618V10.078L39.638,0z M45.008,9.344h-4.543V4.801L45.008,9.344z M21.003,37.188 V2.813h16.649v9.344h9.344v25.031H21.003z"
})));

var SvgNewConvocation = function SvgNewConvocation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "40px",
    viewBox: "0 0 50 40",
    enableBackground: "new 0 0 50 40",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNewConvocation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/newConvocation.55bb8e3d.svg";
export { ForwardRef as ReactComponent };